import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '@/views/Home.vue'
import Product from '@/views/Product.vue'

Vue.use(VueRouter);

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_PATH,
    routes: [
        { path: '/',        component: Home },
        {
            path: '/product/:no(\\d+)',
            component: Product,
            props: route => ({ no: Number(route.params.no) })
        },
        {
          path: '*',
          redirect: '/'
        }
    ],
    scrollBehavior(to, from, savedPosition) {
        
        if (savedPosition) {
            sessionStorage.setItem('positionY', savedPosition.y);
            return false;
        } else {
            if(from.path === '/'){
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
                sessionStorage.setItem('positionY', scrollTop);
            }
            return false;
           // sessionStorage.setItem('positionY', 0);
            //return { x: 0, y: 0 }
        }
    }
});



export default router



// WEBPACK FOOTER //
// ./src/router.js